import _t from 'i18n!nls/stackability-common';

const getDegreesDiscoveryCopy = () => ({
  startWorkingTowardsDegreeName: (degreeName: string) =>
    _t('Start working towards the #{degreeName} degree', { degreeName }),
  startWorkingTowardsDegree: _t('Start working towards a degree'),
});

export default getDegreesDiscoveryCopy;
